import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { verdictOf } from "./EvidenceScorer";

export const EvidenceScoreBadge = ({ disputeId }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/disputes/${disputeId}/evidence-score`).then((r) => setS(r.data)).catch(() => {}); }, [disputeId]);
  if (!s) return null;
  const [label, tone] = verdictOf(s.score);
  return (
    <div className="inline-flex flex-wrap items-center gap-3 mt-3 px-3 py-2 border border-line bg-panel" data-testid="evidence-score-badge"
      title="Evidence score = points for each proof you hold (delivery, emails, logins, terms…). It tells you whether you have enough to defend. Evidence strength (percent) is the model's estimate of how persuasive that proof is for this reason code.">
      <span className="label-xs">Evidence score · points</span>
      <span className={`font-mono text-lg font-extrabold ${tone}`} data-testid="evidence-score-value">{s.score}<span className="text-white/35 text-xs"> · need {s.threshold}+</span></span>
      <span className={`font-mono text-[10px] tracking-wider ${tone}`} data-testid="evidence-score-verdict">{label}</span>
      {s.next_best.length > 0 && <span className="text-[11px] text-white/50" data-testid="evidence-score-next">Add next: {s.next_best.join(", ")}</span>}
      <Link to="/app/manual?tab=score" className="font-mono text-[10px] text-brand hover:underline" data-testid="evidence-score-how">HOW IT'S SCORED →</Link>
    </div>
  );
};
